<template>
  <div class="sessions">
    <div class="sessions-top" v-if="companyDatas">
      <!-- <img src="../../assets/images/newicon/specialBg.png" alt="" style="height: 238px;width: 100%;"> -->
      <div class="sessions-top-content">
        <h5 class="textOver">{{companyDatas.nameCn}}</h5>
        <p class="sessions-top-content-special">IT内推圈招聘专场</p>
        <p>简历截止：{{companyDatas.expirationDate}}</p>
      </div>
    </div>
    <div class="sessions-main">
      <div class="mainLeft">
        <div class="list boxShadow" v-for="(item, index) in companyList" :key="index">
          <!-- 公司 -->
          <div class="company ">
            <div class="flexBetween companyBg">
              <div class="companyLeft">
                <img :src="item.avatarUrl" />
                <div class="companyRight" @click="gotoDetail(item.id)">
                  <a class="title">{{
                    item.nameCn
                  }}</a>
                  <div class="detail">
                    <span>{{ item.companyTypeName }}</span>
                    <span class="detailSeparated"></span>
                    <span>{{ item.scaleTypeName }}</span>
                    <span class="detailSeparated"></span>
                    <span>{{ item.financingTypeName }}</span>
                  </div>
                </div>
              </div>
              <p class="companyLeftTitle">
                <span>{{ item.positionCounts }}</span>个在招职位
              </p>

          </div>
            
          </div>
          <div class="divider"></div>
          <!-- 招聘简介 -->
          <div class="abstract">
            <p class="position">招聘职位：{{ item.positionNames.join(" / ") }}</p>
            <p class="address">专场地址：{{ item.address }}</p>
            <div class="time">
              <p>简历截止：{{ item.expirationDate }}</p>
              <p class="endTime">专场日期：{{ item.effectiveEndList[0] }}</p>
            </div>
          </div>
        </div>
        <!-- 页码 -->
        <pagination
          :total="pagination.totalRow"
          v-model="pageIndex"
          v-if="pagination && !loading"
        ></pagination>
        <!-- 没有数据时候 -->
        <prompt v-if="companyList.length < 1 && !loading" style="margin-top: 20px;"></prompt>
      </div>
      <div class="mainRight">
        <LoginTabs></LoginTabs>
      </div>
    </div>
  </div>
</template>

<script>
import { mapActions, mapState } from "vuex";
import defaultAvatar from "../../assets/images/default-avatar.png";
import { base64 } from "../../libs/utilts";
import LoginTabs from '../../components/loginTab.vue'
export default {
  name: "session",
  data() {
    return {
      loading: true,
      companyList: [], //公司列表
      companyDatas:{},
      pageIndex: 1, //当前页码
      pageSize: 10,
      username: "", //登陆手机号
      password: "", //登陆密码
      captcha: "", //登陆验证码
      captchaLoading: false,
      id: ""
    };
  },
  created() {
    this.getList();
  },
  components:{LoginTabs},
  computed: {
    ...mapState({
      captchaSrc: state => state.user.captcha, //图形验证码
      shlefInfo: state => state.user.info, //个人信息
      pagination: state => state.jobs.sessionPagination
    }),
    defaultAvatar() {
      return defaultAvatar;
    }
  },
  methods: {
    ...mapActions(["login", "getSpecialCompany", "getInitDate"]),
    // 专场数据
    async getList() {
      this.loading = true;
      const res = await this.getSpecialCompany({
        pageIndex: this.pageIndex,
        pageSize: this.pageSize
      });
      if (res) {
        this.companyList = res;
        this.loading = false;
        this.companyDatas = res[0]
      }
    },
    gotoDetail(id){
        window.open(`/company/detail?id=${id}`);
    },
  },
  watch: {
    pageIndex(e) {
      this.getList();
    }
  }
};
</script>
<style lang="less" scoped>
.sessions {
  // background: linear-gradient(360deg, #F9FBFF 0%, #DCEAFF 100%);
  &-top{
    height: 238px;
    background: url('../../assets/images/newicon/specialBg.png') 100% 100%;
    background-size: 100% 100%;
    &-content{
      width: 1280px;
      margin: 0 auto;
      padding-top: 30px;
      h5{
        font-size: 56px;
        font-family: YouSheBiaoTiHei;
        color: #FFFFFF;
        line-height: 73px;
        background: linear-gradient(318deg, #FFFFFF 80%, #FFB448 100%);
        background-clip: text;
        -webkit-background-clip: text;
        -webkit-text-fill-color: transparent;
      }
      p{
        font-size: 24px;
        font-family: YouSheBiaoTiHei;
        color: #FFFFFF;
        line-height: 40px;
      }
      &-special{
        font-size: 32px;
          font-family: YouSheBiaoTiHei;
          color: #FFFFFF;
          line-height: 42px;
          background: linear-gradient(318deg, #FFFFFF 92%, #FFB448 100%);
          background-clip: text;
          -webkit-background-clip: text;
          -webkit-text-fill-color: transparent;
      }
    }
  }
  &-main{
    width: 1280px;
    margin: 30px  auto 0;
    display: flex;
    justify-content: space-between;
    flex-wrap: nowrap;
  }
  .mainLeft {
    width: 954px;
    .list {
      background: #fff;
      margin-bottom: 20px;
      .divider{
        width: 100%;
        height: 1px;
        background: #000000;
        opacity: 0.1;

      }



      .company {
        padding: 10px;
        .companyBg{
          // background: linear-gradient(90deg, #FFDD83 0%, rgba(255,184,76,0) 20%);
          padding: 10px;
        }
        .companyLeft {
          display: flex;
          justify-content: center;
          align-items: center;
          img{
            width: 60px;
            height: 60px;
            border: 2px solid #FF9A00;
            border-radius: 6px;
          }
        }
        .companyLeftTitle{
          font-size: 14px;
          font-family: PingFangSC-Regular, PingFang SC;
          font-weight: 400;
          color: #666666;
          line-height: 25px;
          span{
            font-size: 24px;
            font-family: PingFangSC-Semibold, PingFang SC;
            font-weight: 600;
            color: #FFAC2D;
            padding-right: 4px;
          }
        }
        .companyRight {
          display: flex;
          justify-content: space-between;
          flex-direction: column;
          margin-left: 10px;
          box-sizing: border-box;
          .title {
            font-size: 18px;
            font-family: PingFangSC-Medium, PingFang SC;
            font-weight: 500;
            color: rgba(0,0,0,0.85);
            line-height: 28px;
            padding-bottom: 4px;
          }
          .detail {
            font-size: 14px;
            font-family: PingFangSC-Regular, PingFang SC;
            font-weight: 400;
            color: rgba(102,102,102,0.85);
            line-height: 22px;
            display: flex;
            align-items: center;
            .detailSeparated {
              display: block;
              width: 1px;
              height: 16px;
              background: #D8D8D8;
              margin: 0 16px;
            }
          }
        }
      }
      // 摘要
      .abstract {
        padding: 20px;
        // margin-top: 20px;
        // border-top: 1px solid #e5e5e5;
        font-size: 14px;
        color: #333;
        display: flex;
        flex-direction: column;
        justify-content: space-between;
        height: auto;
        box-sizing: border-box;
        .position{
          font-size: 16px;
          font-family: PingFangSC-Regular, PingFang SC;
          font-weight: 400;
          color: rgba(0,0,0,0.85);
          line-height: 22px;
          padding-bottom: 4px;
        }
        .address {
          font-size: 14px;
          font-family: PingFangSC-Regular, PingFang SC;
          font-weight: 400;
          color: rgba(0,0,0,0.85);
          line-height: 20px;
          padding-bottom: 4px;
        }
        .time {
          display: flex;
          align-items: center;
          margin-top: 10px;
          p {
            text-align: center;
            line-height: 22px;
            margin-right: 20px;
            padding: 0 14px;
            font-size: 12px;
            font-family: PingFangSC-Regular, PingFang SC;
            font-weight: 400;
            color: rgba(0,0,0,0.5);
            background: #FFB84C;
            border-radius: 12px;

          }
          .endTime {
            background: #EBEEFF;
          }
        }
      }
    }
  }
  .mainRight {
    margin-top: 20px;
    width: 302px;
    .home-login {
      // height: 266px;
      background: #fff;
      box-sizing: border-box;
      padding: 0 15px 18px;
      .loginTitle {
        font-size: 16px;
        color: #333;
        text-align: center;
        line-height: 56px;
      }
      .loginParameter {
        height: 30px;
        display: flex;
        align-items: center;
        justify-content: space-between;
        border: 1px solid #e5e5e5;
        box-sizing: border-box;
        padding: 0 10px;
        font-size: 12px;
        color: #333;
        margin-top: 10px;
        .el-input {
          width: 130px;
          height: 100%;
          display: flex;
          justify-content: space-between;
          align-items: center;
        }
        .el-input__inner {
          border: 0;
          padding: 0;
          height: 100%;
          border-radius: 0;
        }
        .el-input-group__append {
          background: none;
          border: 0;
          padding: 0;
          width: 70px;
          img {
            display: block;
            height: 20px;
          }
        }
      }
      .loginParameter:first-of-type {
        margin-top: 0;
      }
      .loginBtn {
        border-radius: 0;
        background: #049cfd;
        display: block;
        width: 100%;
        height: 30px;
        line-height: 30px;
        font-size: 16px;
        color: #fff;
        padding: 0;
        border: 0;
        margin: 20px 0;
      }
      .loginFooter {
        display: flex;
        align-items: center;
        justify-content: center;
        font-size: 14px;
        color: #999;
        .goRegister {
          color: #049cfd;
        }
      }
    }
    // 个人信息
    .information {
      background: #fff;
      box-sizing: border-box;
      .informationMain {
        // height: 266px;
        box-sizing: border-box;
        padding: 30px 0;
        display: flex;
        flex-direction: column;
        justify-content: space-between;
        align-items: center;
        border-bottom: 1px solid #f5f5f5;
        .point {
          display: block;
          width: 80px;
          height: 80px;
          border-radius: 50%;
          margin-bottom: 5px;
        }
        .name {
          font-size: 18px;
          color: #333;
        }
        .delivery-today {
          font-size: 12px;
          color: #999;
          margin-top: 10px;
          span {
            color: #049cfd;
          }
        }
        .amount {
          display: flex;
          justify-content: center;
          align-items: center;
          margin-top: 20px;
          .amountMenu {
            font-size: 14px;
            color: #666;
            text-align: center;
            .amountMenuNumber {
              font-size: 14px;
              color: #049cfd;
              margin-bottom: 14px;
              .number {
                font-size: 24px;
                margin-right: 10px;
              }
            }
          }
          .amountMenu:last-of-type {
            margin-left: 30px;
          }
        }
      }
      .degree {
        height: 80px;
        box-sizing: border-box;
        padding: 17px 15px;
        display: flex;
        flex-direction: column;
        justify-content: space-between;
        font-size: 14px;
        color: #333;
      }
    }
    .advertising {
      display: block;
      width: 100%;
      height: 206px;
      margin: 10px 0;
    }
  }
}
</style>
